import Section from "components/Section";
import Title from "components/Title";
import Card from "containers/Card";
import { motion } from "framer-motion";
import React, { useMemo } from "react";
import { framerMotionAnimation } from "utils/animation";
import urls from "utils/urls";
import styles from "./styles.module.scss";

const Team: React.FC = () => {
  const members = useMemo(
    () => [
      {
        name: "Rafael Maceda",
        role: "Chief Executive Officer",
        description:
          "Ram is a Registered Electrical Engineer with extensive experience in the clean energy industry and consulting. He is skilled in solar engineering, electrical design, quantity surveying, financial modeling, and technical consulting, excelling as an engineering executive or consultant.",
        image: urls.images("members/rafael.jpg"),
      },
      {
        name: "Kristel Matanguihan ",
        role: "Chief Marketing Officer",
        description:
          "Kristel is an experienced sales and marketing manager, skilled in digital and traditional marketing campaigns. She excels at creating client-focused campaigns to enhance brand awareness and managing social media platforms to achieve goals like brand awareness, consideration, and conversion.",
        image: urls.images("members/kristel.jpg"),
      },
      {
        name: "Gordon Bautista",
        role: "Chief Operating Officer",
        description:
          "Gordon holds a BS Electrical Engineering from the University of the Philippines and is a Registered Electrical Engineer, specializing in solar design engineering, project management and development. Previously led the construction efforts for a 20 MW Solar Power Plant.",
        image: urls.images("members/gordon.jpg"),
      },
    ],
    []
  );

  return (
    <Section className={styles.container} id="team" label="Our Team">
      <Title title="Meet your <highlight>Solar Experts</highlight>" />

      <div className={styles.list}>
        {members.map((member) => (
          <motion.div {...framerMotionAnimation} key={member.name}>
            <Card
              className={styles.card}
              description={member.description}
              image={member.image}
              key={member.name}
              subtitle={member.role}
              title={member.name}
            />
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default Team;
